import { combineReducers } from "@reduxjs/toolkit";
import loadSla from "./load-sla/dataSlice";
import loadSlaDashboard from "./load-sla-dashboard/dataSlice";
import loadSubmissions from "./load-submissions/dataSlice";
import upsertSlaAnswerTags from "./upsert-sla-answer-tags/dataSlice";

const reducer = combineReducers({
  loadSla,
  loadSubmissions,
  upsertSlaAnswerTags,
  loadSlaDashboard,
});

export default reducer;
